import { RequestConfig } from '~/common/services/requests';
import { DocumentMessage } from '../../../../types';
import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructGet } from '../../../types/ConstructGet';
import { PaginatedResponse } from '../../../types/PaginatedResponse';
import { MIDDLE_OFFICE_BASE_PATH } from '../../constants/middleOfficeBasePath';

export const getApplicationMessages = async (
  constructGet: ConstructGet,
  uuid: string,
  definitionName: string,
  params?: RequestConfig['params'],
): Promise<PaginatedResponse<DocumentMessage[]> | undefined> =>
  constructGet(`${MIDDLE_OFFICE_BASE_PATH}/${uuid}/messages`, {
    params,
    headers: {
      [InceptHeader.DefinitionName]: definitionName,
    },
  });
